const CONFIG_MAP: Record<string, any> = {
  /** 银行名称，无需权限接口 */
  BankName: {
    url: '/common/batch/enumeration/no_auth',
    method: 'post',
    dataPath: 'BANK_NAME',
    enableCustomItems: true,
    fieldNames: {
      label_name: 'item',
      label_text: '',
      value_name: 'item'
    },
    searchParams: ['BANK_NAME']
  },
  /** 岗位 */
  Post: {
    url: '/hrm/post/search',
    method: 'post',
    fieldNames: {
      label_name: 'post_name',
      label_text: 'post_code',
      value_name: 'id'
    }
  },
  /** 职级 */
  Rank: {
    url: '/hrm/position/ranks',
    method: 'post',
    fieldNames: {
      label_name: 'name',
      label_text: 'code',
      value_name: 'id'
    }
  },
  /** 职务 */
  Position: {
    url: '/hrm/positions',
    method: 'post',
    fieldNames: {
      label_name: 'name',
      label_text: 'code',
      value_name: 'id'
    }
  },
  /** 排班 */
  Schedule: {
    url: '/schedule/shifts',
    method: 'post',
    fieldNames: {
      label_name: 'name',
      label_text: 'code',
      value_name: 'id'
    }
  },
  // TODO: ff
  /** 工种 */
  Regular: {
    url: '/schedule/temp/regular/list',
    method: 'post',
    fieldNames: {
      label_name: 'name',
      label_text: 'code',
      value_name: 'id'
    }
  },
  /** 合同公司 */
  ContractsSubjects: {
    url: '/hrm/contracts/subject/search',
    method: 'post',
    fieldNames: {
      label_name: 'customer_name',
      label_text: '',
      value_name: 'id'
    },
    searchParams: {
      status: 1
    }
  },
  /** 工作地点 */
  WorkLocation: {
    url: '/hrm/workplaces',
    method: 'post',
    fieldNames: {
      label_name: 'name',
      label_text: 'code',
      value_name: 'id'
    }
  },
  /** 考勤方案 */
  AttendanceScheme: {
    url: '/attendance/schemes',
    method: 'get',
    fieldNames: {
      label_name: 'name',
      label_text: 'remark',
      value_name: 'id'
    }
  },
  /** 薪酬方案 */
  SalaryScheme: {
    url: '/rule/salary/schemes',
    method: 'post',
    fieldNames: {
      label_name: 'name',
      label_text: 'code',
      value_name: 'id'
    }
  },
  /** 企业筛选 */
  Company: {
    url: '/tax/agent/company/offices',
    method: 'post',
    fieldNames: {
      label_name: 'company_name',
      label_text: '',
      value_name: 'id'
    }
  },
  /** 供应商 */
  RecruitSupplier: {
    url: '/recruit/suppliers',
    method: 'post',
    fieldNames: {
      label_name: 'name',
      label_text: 'code',
      value_name: 'code'
    }
  }
}

export default CONFIG_MAP
